<template>
  <div>

    <el-row type="flex" :gutter="6">
      <el-col :span="5">
        <el-input
            :clearable="true"
            style="width: 100%"
            placeholder="Nhập tên hoặc số điện thoại"
            v-model="nameOrPhone"
            @keyup.enter.native="handleFilterData"
            @clear="handleFilterData"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="handleFilterData"
            ></el-button>
          </template>
        </el-input>
      </el-col>


    </el-row>
    <div style="margin-top: 5px"></div>
    <div>
      <el-table
          border
          :data="dataList"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          v-loading="isLoading"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          ref="tablePlus"
      >
        <el-table-column
            type="selection"
            width="100"
            align="center"
            fixed="left"
        />

        <el-table-column
            type="index"
            label="STT"
            align="center"
            width="100"
            fixed="left"
        />

        <el-table-column
            label="Họ và tên"
            fixed="left"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.fullName }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Số điện thoại"
            fixed="left"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="300" label="Cho phép tạo nhóm chat">
          <template #header>
            <span class="second-title">Cho phép tạo nhóm chat</span>
            <br/>
            <el-checkbox
                @change="checkBoxAllPlusCreateGroupChat()"
                v-model="checkAllPlusCreateGroupChat"
            ></el-checkbox>
          </template>
          <template v-slot:default="scope">
            <el-checkbox
                v-model="scope.row.plusCreateGroupChat"
            ></el-checkbox>
          </template>
        </el-table-column>

<!--        <el-table-column align="center" width="300" label="Xem tin nhắn chat nhóm">-->
<!--          <template v-slot:default="scope">-->
<!--            <el-checkbox-->
<!--                v-model="scope.row.plusSeeMessageChatGroup"-->
<!--            ></el-checkbox>-->
<!--          </template>-->
<!--        </el-table-column>-->

<!--        <el-table-column align="center" width="300" label="Xem tin nhắn chat riêng">-->
<!--          <template v-slot:default="scope">-->
<!--            <el-checkbox-->
<!--                v-model="scope.row.plusSeeMessageChatSingle"-->
<!--            ></el-checkbox>-->
<!--          </template>-->
<!--        </el-table-column>-->


        <template #empty>
          <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
          </div>
        </template>
      </el-table>
      <!--  Phân trang & tác vụ  -->
      <section style="margin-top: 20px">
        <el-row type="flex" :gutter="4">
          <el-col :span="22">
            <div class="container_nav_page">
              <el-pagination
                  background
                  layout="prev, pager, next, sizes"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentPageChange"
                  :current-page.sync="page"
                  :page-sizes="listSizePage"
                  :total="totalRecords">
              </el-pagination>
            </div>
          </el-col>

          <el-col :span="2">
            <div class="container_task">
              <el-button
                  type="success"
                  size="medium"
                  :loading="loadingButton"
                  @click="submitForm()"
                  icon="el-icon-circle-check"
              >
                <span>Lưu</span>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </section>
    </div>
  </div>
</template>

<script>
import SupperPlusService from "@/services/SupperPlusService";

export default {
  components: {},
  created() {
    this.getDataInitial()
  },
  // computed: {
  //   ...mapState('gradeModule', ['gradeOfSchoolList']),
  //   ...mapState('classStore', ['classListCommon']),
  //   ...mapState('departmentStore', ['departmentList']),
  //   classList() {
  //     return this.classListCommon.filter((x) => x.idGrade === this.dataSearchParent.idGrade);
  //   },
  // },
  data() {
    return {
      nameOrPhone: "",
      page: 1,
      limit: 10,
      totalRecords: 0,
      dataList: [],
      configParentList: [],
      listSizePage: [10, 30, 40, 50],
      loadingButton: false,
      multipleSelection: [],
      isLoading: false,
      checkAllPlusCreateGroupChat: false,

    };
  },
  watch: {},
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },

    getDataInitial() {
      SupperPlusService.searchConfigRoleUserChatEmployee(this.page, this.limit, "plus", this.nameOrPhone)
          .then((resp) => {
            this.dataList =
                resp.data.data.responseList
            this.totalRecords = resp.data.data.totalRecords
          })
          .catch((err) => {
            console.log(err);
          });
    },

    clearTabDefault() {
    },
    handleSizeChange(value) {
      this.limit = value;
      this.getDataInitial();
    },
    handleCurrentPageChange(value) {
      this.page = value;
      this.getDataInitial();
    },

    handleFilterData() {
      this.page = 1;
      this.getDataInitial();
    },
    submitForm() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "Không có plus nào được chọn",
          type: "error",
        });
      } else {
        this.updateForManyPlus();
      }

    },

    updateForManyPlus() {
      this.loadingButton = true;
      SupperPlusService.updateForManyPlus(this.multipleSelection)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: resp.data.data === true ? "success" : "error",
            });
            setTimeout(() => {
              this.getDataInitial()
              this.loadingButton = false;
            }, 500);
            this.resetSelection();
          })
          .catch((err) => {
            this.$message({
              message: err.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    resetSelection() {
      this.multipleSelection = [];
      this.$refs.tablePlus.clearSelection();
    },

    checkBoxAllPlusCreateGroupChat(){
      let dataList = this.dataList;
      dataList.forEach((x) => {
        x.plusCreateGroupChat = this.checkAllPlusCreateGroupChat
      });
    },
  },
};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
  background: #e7e9ec;
  border: 1px solid #dcdfe6;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
  margin-right: 50px;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

.table-data {
  width: 60%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  margin: 0 auto;
}

.wrapper-table {
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

.button-left-class {
  margin-right: 5px;
  width: 200px;
}

.button-click-left {
  margin-top: 5px;
  display: flex;
  align-items: center;
  margin-bottom: -20px;
  position: relative;
  z-index: 1
}

.button-click-left .el-select {
  margin-right: 10px;
}

.footer_task {
  margin-top: 20px;
}
.container_task {
  display: flex;
  justify-content: right;
}
.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
